import { Extension } from "@tiptap/core"

/**
 * Thin UI companion for the official FindAndReplace extension.
 * Owns panel open state and Mod-f; search/replace lives in
 * `@tiptap/extension-find-and-replace`.
 */
export const FindReplaceUi = Extension.create({
  name: "findReplace",

  addStorage() {
    return {
      uiOpen: false,
    }
  },

  addKeyboardShortcuts() {
    return {
      "Mod-f": () => this.editor.commands.openFindReplace(),
    }
  },

  addCommands() {
    return {
      openFindReplace: () => ({ editor, tr, dispatch }) => {
        editor.storage.findReplace.uiOpen = true
        if (dispatch) {
          dispatch(tr.setMeta("findReplaceUi", { type: "open" }))
        }
        return true
      },

      closeFindReplace: () => ({ editor, tr, dispatch }) => {
        editor.storage.findReplace.uiOpen = false

        // Always dispatch so use-find-replace's transaction listener sees uiOpen=false
        // even when clearSearch is a no-op and would not create a transaction.
        if (dispatch) {
          dispatch(tr.setMeta("findReplaceUi", { type: "close" }))
        }

        // Clear highlights after the UI-close transaction (separate command /
        // transaction). Ignore its return value — it must not make close fail.
        if (typeof editor.commands.clearSearch === "function") {
          editor.commands.clearSearch()
        }

        return true
      },
    }
  },
})

export default FindReplaceUi
